import React from 'react';
import { StyledInput } from '../JRCStyledInput';
import { useIntl } from 'react-intl';
import { useDebouncedCallback } from '../../../../hooks/UseDebounce';
import { JRCIcon } from '../../../JRCIcon/JRCIcon';
import styled, { useTheme } from 'styled-components';
import { JRCLoader } from '../../../JRCLoader/JRCLoader';
import { JRCTypography } from '../../../JRCTypography/JRCTypography';
import { DataCy } from '../../../../types/dataAttributes';

export type JRCInputSearchProps = {
    onChange?: (v: string) => void;
    onClickSearch?: (v: string) => void;
    placeholder?: string;
    width?: number | string;
    loading?: boolean;
} & DataCy;

const Container = styled.div<{ width: string | number }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};
`;

const IconWrapper = styled.div`
    position: absolute;
    margin-left: 8px;
    margin-top: 3px;
`;

const InputContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
`;

const SearchButton = styled.button`
    background-color: ${({ theme }) => theme.color.primary};
    color: ${({ theme }) => theme.color.white};
    position: absolute;
    height: 40px;
    padding: 0 20px;
    border-radius: 0 8px 8px 0;
    transition: background-color 0.5s;

    &:hover {
        background-color: ${({ theme }) => theme.color.primaryL15};
    }
`;

export const JRCInputSearchRaw = ({
    onChange,
    placeholder,
    width,
    loading,
    onClickSearch,
    dataCy,
}: JRCInputSearchProps) => {
    const intl = useIntl();
    const theme = useTheme();
    const { debouncedFunction: debouncedOnChange, value: query } = useDebouncedCallback(onChange);

    return (
        <Container width={width || '100%'}>
            <IconWrapper>
                {loading ? <JRCLoader size="s" /> : <JRCIcon name="icon-search" color={theme.color.grey2} size={18} />}
            </IconWrapper>
            <InputContainer>
                <StyledInput
                    style={{ width: width || '100%', paddingLeft: '40px', paddingRight: '130px', marginBottom: 0 }}
                    placeholder={placeholder || intl.formatMessage({ id: 'GLOBAL_Search' })}
                    type="text"
                    onChange={(e) => debouncedOnChange(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && query && onClickSearch) {
                            onClickSearch(query);
                        }
                    }}
                    data-cy={dataCy}
                />
                {onClickSearch && (
                    <SearchButton
                        onClick={() => {
                            if (query) onClickSearch(query);
                        }}>
                        <JRCTypography>{intl.formatMessage({ id: 'GLOBAL_Search' })}</JRCTypography>
                    </SearchButton>
                )}
            </InputContainer>
        </Container>
    );
};
